import { Plane, PlaneLanding, PlaneTakeoff } from 'lucide-react'
import { SCHEDULE_ENTRIES, DEMO_NOW_TIME, type ScheduleEntry } from '../data/scheduleData'

function timeToMinutes(t: string) {
  const [h, m] = t.split(':').map(Number)
  return h * 60 + m
}

const STATUS_STYLES: Record<ScheduleEntry['status'], string> = {
  completed: 'opacity-40 bg-white/5',
  active:    'bg-sky-500/20 border border-sky-500/40 text-sky-300',
  upcoming:  'bg-white/8 border border-white/10 text-white/80',
  inbound:   'bg-amber-500/20 border border-amber-400/50 text-amber-200 animate-pulse',
}

function MovementPill({ entry }: { entry: ScheduleEntry }) {
  const Icon = entry.type === 'arrival' ? PlaneLanding : PlaneTakeoff
  return (
    <div className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs whitespace-nowrap flex-shrink-0 transition-all ${STATUS_STYLES[entry.status]} ${entry.isHero ? 'ring-1 ring-amber-400/60' : ''}`}>
      <Icon className="w-3 h-3 flex-shrink-0" />
      <span className="font-mono font-semibold">{entry.tailNumber}</span>
      <span className="text-current/60 hidden sm:block">{entry.aircraftType}</span>
      <span className="font-semibold">{entry.time}</span>
      {entry.isHero && (
        <span className="text-amber-300 font-bold text-[10px] uppercase tracking-wide ml-1">
          INBOUND
        </span>
      )}
    </div>
  )
}

function NowMarker() {
  return (
    <div className="flex flex-col items-center flex-shrink-0 mx-2">
      <div className="w-px h-3 bg-sky-400" />
      <div className="bg-sky-400 text-white text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wide">
        NOW {DEMO_NOW_TIME}
      </div>
      <div className="w-px h-3 bg-sky-400" />
    </div>
  )
}

export function TimelineStrip() {
  const nowMinutes = timeToMinutes(DEMO_NOW_TIME)
  const sorted = [...SCHEDULE_ENTRIES].sort(
    (a, b) => timeToMinutes(a.time) - timeToMinutes(b.time)
  )
  const past   = sorted.filter((e) => timeToMinutes(e.time) <  nowMinutes)
  const future = sorted.filter((e) => timeToMinutes(e.time) >= nowMinutes)

  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 pointer-events-none z-10 w-[calc(100%-2rem)] max-w-4xl">
      <div className="bg-slate-900/80 backdrop-blur-md border border-white/10 rounded-xl px-4 py-2 shadow-xl overflow-x-auto">
        <div className="flex items-center gap-2 min-w-max">
          <div className="flex items-center gap-1.5 mr-2 flex-shrink-0">
            <Plane className="w-3.5 h-3.5 text-white/40" />
            <span className="text-[10px] text-white/40 uppercase tracking-widest font-semibold">
              OPA-LOCKA · TODAY
            </span>
          </div>
          {past.map((e) => <MovementPill key={e.id} entry={e} />)}
          <NowMarker />
          {future.map((e) => <MovementPill key={e.id} entry={e} />)}
        </div>
      </div>
    </div>
  )
}
